import { DetectedVirusList } from './DetectedVirusList';
import { RelatedFoods } from './RelatedFoods';
import { ReturnButton } from '@/components/shared/ReturnButton';
import { useGetPlantVirusDataV2 } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { useLocation } from 'react-router-dom';
import { DataCardsCarousel } from '../BloodSugarResponsePage/DataCardsCarousel';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';
import PlantVirusCard from '@screens/HomePage/PlantVirusPage/PlantVirusCard';

export const PlantVirusPage = () => {
  const { data: plantVirusData, isLoading, isError } = useGetPlantVirusDataV2();
  const location = useLocation();
  const { id } = location.state || {};

  if (isError) {
    return <ErrorLoadingPage />;
  }

  if (isLoading) {
    return (
      <section className="page-container">
        <div className="min-h-screen bg-background-secondary p-6 space-y-8">
          <Skeleton className="h-10 w-48" />
          <Skeleton className="h-20 w-full" />
          <div className="space-y-4">
            <Skeleton className="h-8 w-64" />
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-16 w-full" />
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-24 w-full rounded-xl" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!plantVirusData) return null;

  return (
    <section className="page-container">
      <div className="min-h-screen bg-background-secondary p-6 space-y-8">
        <ReturnButton />
        <h1 className="typography-d2 text-primary">
          {plantVirusData?.summary.title}
        </h1>
        <div className="flex items-start gap-2">
          <p className="typography-body text-primary/70">
            {plantVirusData?.summary.info}
            <PlantVirusCard
              description={plantVirusData?.summary.description}
              title="About Plant Viruses"
            />
          </p>
        </div>
        <DetectedVirusList viruses={plantVirusData?.detected_plant_viruses} />
        <RelatedFoods
          foods={plantVirusData?.summary.foods.map((food) => ({
            id: food.food_id,
            name: food.food_name,
            image_url: food.food_image,
            rank: food.food_rank,
          }))}
        />
        <DataCardsCarousel scoreId={id} />
      </div>
    </section>
  );
};
